'use strict';

function rangeHoverLink(scope, el) {
  const parent = scope.$parent;

  el.on('mouseenter', 'button', function() {
    const cellScope = angular.element(this).scope();
    if (cellScope && cellScope.dt && parent.setHoverDate) {
      scope.$apply(function() {
        parent.setHoverDate(cellScope.dt.date);
      });
    }
  });

  el.on('mouseleave', function() {
    if (parent.clearHoverDate) {
      scope.$apply(function() {
        parent.clearHoverDate();
      });
    }
  });

  scope.$on('$destroy', function() {
    el.off('mouseenter mouseleave');
  });
}

function rangeHover() {
  return {
    restrict: 'A',
    link: rangeHoverLink
  };
}

angular.module('webAgro1App').directive('rangeHover', rangeHover);
